(function() {
  function isWebView() {
    try {
      var ua = navigator.userAgent || '';
      var ios = /iPhone|iPod|iPad/i.test(ua);
      var safari = /Safari/i.test(ua);
      var standalone = window.navigator ? window.navigator.standalone : false;
      var androidWV = /\bwv\b|Android.*Version\/[\d.]+/i.test(ua);
      var hasBridge = typeof window.ReactNativeWebView !== 'undefined';
      return hasBridge || (ios && (!safari || standalone === true)) || androidWV;
    } catch(e) {
      return false;
    }
  }

  function setSaleSource() {
    var params = new URLSearchParams(window.location.search);
    var saleSourceParam = params.get('sale_source');
    var saleSource = saleSourceParam ? decodeURIComponent(saleSourceParam) : null;

    if (!saleSource && isWebView()) {
      saleSource = 'App';
    }

    // If no param → stop
    if (!saleSource) return;

    // Save locally
    try {
      localStorage.setItem('sale_source', saleSource);
    } catch(e) {
      console.warn('Could not save sale_source to localStorage', e);
    }

    // Push into cart attributes if missing or different
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        var current = (cart.attributes && cart.attributes.sale_source) || null;
        if (current !== saleSource) {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              attributes: { sale_source: saleSource }
            })
          }).catch(err => console.error('Failed to update cart attribute', err));
        }
      })
      .catch(err => console.error('Error fetching cart', err));
  }

  // Run once on page load
  setSaleSource();

  // Re-run on navigation (for SPA-like stores)
  var pushState = history.pushState;
  history.pushState = function() {
    pushState.apply(history, arguments);
    setTimeout(setSaleSource, 200);
  };
  window.addEventListener('popstate', setSaleSource);
})();
